<template>
    <div v-if="details" class="state-main" v-title="'国家认证'">
        <img :src="details.detailimgurl" alt="图片" />
        <div class="sticky-card" v-if="!details.authStatus || details.authStatus == 1 || details.authStatus == 30 || details.authStatus == 60 || details.authStatus == 0">
            <van-cell is-link @click="showPopup" title="优惠券" :value="couponCounts" v-if="!details.isDiscount"></van-cell>
            <div class="state-sign" v-if="!details.isDiscount">
                <span>￥{{details.authprice}}</span>
                <button @click="immApply">立刻报名</button>
            </div>
            <div class="state-sign" v-else>
                <span>￥{{details.seconddiscountprice}}<i>￥{{details.authprice}}</i></span>
                <button @click="getCreateAuthPayOrder">重新报名</button>
            </div>
        </div>
        <div class="sticky-card" v-else>
            <div class="state-sign">
                <span>已报名</span>
                <button @click="lookDetails">查看详情</button>
            </div>
        </div>
        <van-popup 
            v-model="show" 
            position="bottom" 
            closeable
            :close-on-click-overlay = false
            @click-close-icon="closeShow"
        >
            <!-- :style="{ height: '60%' }" -->
            <div class="coupons-popup">
                <h3 class="coupons-title">请选择优惠券</h3>
                <div class="coupons-box">
                    <div class="coupons-list">
                        <van-radio-group v-model="checked">
                            <div class="coupons-item" 
                                v-for="(item,index) in couponList" 
                                :key="index" 
                                @click="getCoupons(item)"
                            >
                                <div class="item-lfet" v-if="item.CouponMode == 2">{{item.OffAmount}}<span class="zhe">折</span></div>
                                <div class="item-lfet" v-else>￥{{item.OffAmount}}</div>
                                <div class="item-right">
                                    <div class="items-tips">
                                        <span class="dbg">{{item.CouponTypeStr}}</span>
                                        <span class="ts">{{item.UseScopeStr}}</span>
                                    </div>
                                    <label for="">{{item.CouponModeStr}}</label>
                                    <p>{{item.EffectivityEndTime}}</p>
                                </div>
                                <div class="radio">
                                    <van-radio :name="item.Id" checked-color="#ee0a24"/>
                                </div>
                            </div>
                        </van-radio-group>
                    </div>
                </div>
                <div class="footer-btn">
                    <button @click="clickUse">使用</button>
                </div>
            </div>
        </van-popup>
        <div class="wx-mask" v-if="isShowWX" @click="isShowWX=false"></div>
    </div>
</template>
<script>
import {
    configDetails,              //国家认证 || 原厂认证详情
    GetUsableCouponList,        //获取可用优惠券数量
    GetAfterDiscountsAmount,    //获取优惠券后的价格
    authApply,                  //获取payid
    CreateAuthPayOrder,         //获取面试payid
} from '@/common/api.js'
import bridge from '@/common/dsbridge.js';
import {
    mapState
} from 'vuex'
let u = navigator.userAgent;
let ua = navigator.userAgent.toLowerCase();
export default {
    data(){
        return {
            show: false,
            checked: 0,
            details: null,

            appUserInfo: null,              //app里的用户信息
            userid: Number,                 //app里的用户id 不带p
            isWeb: true,                    //是否是浏览器 true 是 false 否

            couponList: [],                 //优惠券列表
            couponCounts: '暂无可用',       //优惠券可用数量

            optionRow: null,                //选择的优惠券

            isShowWX: false,
        }
    },
    computed: {
        ...mapState({
            userData: state => state.userData,
            createConfig: state => state.createConfig,
        }),
    },
    created() {
        this.isWeb=typeof(bridge.call('getUserInfo'))==='undefined'?true:false;
        this.getUserInfo()
    },
    mounted() {
        let self = this;
        bridge.register('notifyLoginSuccess', function () {
            self.getUserInfo();
        });
    },
    methods: {
        showPopup(){
            if(!this.userData && this.isWeb) {
                return this.$router.push({ path: "/login/personLogin" });
            }
            if(!this.couponList.length) return
            this.show = true
        },
        
        
        getUserInfo(){
            let info = bridge.call('getUserInfo') || null;
            if(info) {
                this.appUserInfo = JSON.parse(info);
                if (this.appUserInfo.userId.indexOf('p') === 0) {
                    this.userid = Number(this.appUserInfo.userId.substr(1));
                }
            }
            this.getConfigDetails()
        },
        // 18639990338
        // 18811461535
        // 17012340002
        // 获取国家认证详情
        getConfigDetails(){
            let data = {}
            data.authConfigId = this.$route.query.id;
            data.authType = 1;
            if(this.appUserInfo && !this.isWeb) {
                data.nuserId = this.userid
                data.nuserType = 1;
            }else if(this.userData && this.isWeb) {
                data.nuserId = this.userData.UserId
                data.nuserType = 1;
            }
            configDetails(data).then(res=>{
                if(res.Result != 1) {
                    return this.$toast('请重新获取');
                }
                this.details = res.Data
                if(this.appUserInfo && !this.isWeb 
                || this.userData && this.isWeb) {
                    this.getUsableCouponList()
                }
            })
        },
        // 获取优惠券数量
        getUsableCouponList(){
            let data = {}
            if(this.appUserInfo && !this.isWeb) {
                data.UserCode = this.appUserInfo.userId
            }else if(this.userData && this.isWeb) {
                data.UserCode = this.userData.UserCode
            }
            data.PageNum = 1;
            data.PageSize = 99;
            data.JobId = 0;
            data.ApplyOrderId = 0;
            data.IsValidFullReduce = false;
            data.WhoUseTypes = 59;
            GetUsableCouponList(data).then(res => {
                if(res.Result == 1) {
                    if(!res.Data || res.Data.UsableCouponCounts == 0) {
                        this.couponCounts = '暂无可用'
                    }else {
                        this.couponCounts = res.Data.UsableCouponCounts+'张可用'
                        this.couponList = res.Data.UsableCouponList || []
                    }
                }
            })
        },
        // 选择优惠券
        getCoupons(row) {
            this.optionRow = row
            this.checked = row.Id
        },
        // 关闭
        closeShow(){
            this.optionRow = null
            this.checked = 0
            this.getUsableCouponList()
        },
        clickUse(){
            if(!this.optionRow) {
                this.$notify('请选择优惠券')
                return 
            }
            if(this.optionRow.CouponMode == 2) {
                this.couponCounts = this.optionRow.OffAmount+'折'
            }else {
                this.couponCounts = '-￥'+this.optionRow.OffAmount
            }
            this.checked = this.optionRow.Id
            this.show = false
            let data = {}
            data.JobId = 0;
            data.ApplyOrderId = 0;
            data.PayBusinessType = 4;
            data.CouponId = this.checked
            data.AuthConfigId = this.$route.query.id
            GetAfterDiscountsAmount(data).then(res=> {
                this.details.authprice = res.Data.TotalAmount
            })
        },
        // 点击立刻报名
        immApply(){
            if(!this.userData && this.isWeb) {
                return this.$router.push({ path: "/login/personLogin" });
            }
            // app是否实名认证
            if(!this.isWeb && !this.appUserInfo.isrealname) {
                return bridge.call('jumpRealName');
            }
            // web是否实名认证
            if(this.isWeb && !this.userData.RealNameStatus) {
                return this.$router.push('/personRealName')
            }
            this.getAuthApply()
            
        },
        // 获取payid
        getAuthApply(){
            let data = {}
            data.authConfigId = this.$route.query.id
            data.authStatus = 1
            if(this.appUserInfo && !this.isWeb) {
                data.nuserId = this.userid
            }else if(this.userData && this.isWeb) {
                data.nuserId = this.userData.UserId
            }
            data.nuserType = 1
            data.userCouponId = this.checked
            data.paySenceCode = 1
            authApply(data).then(res=> {
                if(res.Result != 1) {
                    return this.$notify(res.Message)
                }
                // app打开支付
                if(!this.isWeb) {
                    let r = {
                        payId:res.Data
                    }
                    bridge.call('jumpPay', r);
                }else {
                    this.$router.push({
                        path:'/pay',
                        query: {
                            payId:res.Data,
                            from:2,
                            jobId: 0,
                        }
                    })
                }
            })
        },
        getCreateAuthPayOrder(){
            let data = {}
            data.UserCouponId = 0
            data.AccRecordId = this.details.recordid
            if(this.appUserInfo && !this.isWeb) {
                data.UserId = this.userid
            }else if(this.userData && this.isWeb) {
                data.UserId = this.userData.UserId
            }
            data.IsDiscount = this.details.isDiscount
            data.PaySenceCode = 2
            CreateAuthPayOrder(data).then(res=> {
                if(res.Result != 1) {
                    return this.$notify(res.Message)
                }
                // app打开支付
                if(!this.isWeb) {
                    let r = {
                        payId:res.Data.PayId
                    }
                    bridge.call('jumpPay', r);
                }else {
                    this.$router.push({
                        path:'/pay',
                        query: {
                            payId:res.Data.PayId,
                            from:2,
                            jobId: 0,
                        }
                    })
                }
            })
        },
        // 点击查看详情
        lookDetails(){
            if(!this.isWeb) {
                bridge.call('jumpAuthList','1')
            }else{
                this.openAPP()
            }
        },
        openAPP: function () {
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                this.isShowWX = true;
                return;
            }
            
            if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
                console.log('安卓');
                window.location.href = `gongkongsupai://com.gongkong.supai?launchType=17&authType=1`;
                clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    window.location.href = 'https://wx.insupai.com/download/download.html';
                    clearTimeout(this.timer);
                }, 3000);
            } else if (u.indexOf('iPhone') > -1) {
                console.log('苹果');
                window.location.href = `gongkongsupai://param?launchType=17&authType=1`;
                clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    window.location.href = 'https://wx.insupai.com/download/download.html';
                    clearTimeout(this.timer);
                }, 3000);
            }
        },
    }
}
</script>
<style lang="scss">
    @import '~@/style/_base.scss';
    .state-main {
        img {
            display: block;
            max-width: 100%;
            height: auto;
            object-fit: cover;
            min-height: 100vh;
        }
        .sticky-card {
            position: sticky;
            bottom: 0;
            padding-bottom: 20px;
            background: #ffffff;
            .van-cell {
                // height: px2rem(100px);
                background: #f1f1f1;
            }
            .van-cell__title {
                color: #333333;
                span {
                    font-size: px2rem(24px);
                }
            }
            .van-cell__value {
                color: #f75959;
                span {
                    font-size: px2rem(24px);
                }
            }
            .state-sign {
                padding: px2rem(20px) px2rem(28px) 0;
                display: flex;
                align-items: center;
                justify-content: space-between;
                span {
                    color: #f75959;
                    font-size: px2rem(40px);
                    font-weight: bold;
                    i {
                        color: #999999;
                        text-decoration: line-through;
                        font-size: px2rem(24px);
                        padding-left: px2rem(20px);
                    }
                }
                button {
                    width: px2rem(250px);
                    height: px2rem(80px);
                    color: #ffffff;
                    font-size: px2rem(32px);
                    background: #f75959;
                    border-radius: px2rem(40px);
                }
            }
        }
    }
    .coupons-popup {
        .coupons-title {
            text-align: center;
            font-size: px2rem(36px);
            line-height: px2rem(120px);
        }
        .coupons-box {
            .coupons-list {
                overflow-y: scroll;
                max-height: px2rem(720px);
                .coupons-item {
                    margin: 0 px2rem(28px);
                    height: px2rem(180px);
                    background: #f9f9f9;
                    display: flex;
                    align-items:flex-start;
                    position: relative;
                    margin-bottom: px2rem(30px);
                    .item-lfet {
                        min-height: px2rem(180px);
                        min-width: px2rem(240px);
                        max-width: px2rem(240px);
                        @include bg('~@/assets/certification/coupons-icon.png');
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        color: #ffffff;
                        font-size: px2rem(64px);
                        font-weight: bold;
                        .zhe {
                            display: inline-block;
                            padding-left: px2rem(6px);
                            margin-top: px2rem(20px);
                            font-size: px2rem(30px);
                        }
                    }
                    .item-right {
                        flex: 1;
                        padding-left: px2rem(24px);
                        position: relative;
                        height: px2rem(180px);
                        .items-tips {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            padding-top: px2rem(14px);
                            span {
                                font-size: px2rem(24px);
                                line-height: px2rem(32px);             
                            }
                            .dbg {
                                color: #ffffff;
                                background: #00A0E9;
                                border-radius: px2rem(20px);
                                padding: px2rem(6px) px2rem(14px);
                            }
                            .ts {
                                color: #333333;
                                padding-right: px2rem(24px);
                            }
                        }
                        label {
                            color: #333333;
                            font-size: px2rem(30px);
                            font-weight: 500;
                            line-height: px2rem(60px);
                            // margin-top: px2rem(27px);
                            padding-bottom: px2rem(15px);
                        }
                        p {
                            color: #999999;
                            font-size: px2rem(24px);
                            line-height: px2rem(70px);
                            position: absolute;
                            bottom: 0;
                        }
                    }
                    .radio {
                        position: absolute;
                        right: px2rem(24px);
                        top: 50%;
                        transform: translateY(-50%);
                    }
                }
                // .img-icon {
                //     width: px2rem(40px);
                // }
            }
        }
        .footer-btn {
            padding-top: px2rem(35px);
            padding-bottom: px2rem(35px);
            padding-left: px2rem(28px);
            padding-right: px2rem(28px);
            button {
                width: 100%;
                height: px2rem(80px);
                background: #f75959;
                color: #ffffff;
                font-size: px2rem(32px);
            }
        }
    }

    .wx-mask {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 999;
        background: url('~static/image/pointer.png');
        background-size: cover;
    }
</style>